import { ref, query, equalTo, orderByChild } from "firebase/database";
import { useContext, useEffect, useState } from "react";
import { useList, useListVals } from "react-firebase-hooks/database";
import { getDownloadURL, getStorage, ref as storageRef, uploadBytes, uploadBytesResumable } from "firebase/storage";

import { DataContext } from "contexts/DataContext";

const MIME_BY_EXT = {
  mp4: 'video/mp4', mov: 'video/quicktime', m4v: 'video/x-m4v', webm: 'video/webm',
  avi: 'video/x-msvideo', mkv: 'video/x-matroska',
  jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', gif: 'image/gif', webp: 'image/webp',
}

const guessContentType = (filename) => {
  const ext = (filename.split('.').pop() || '').toLowerCase()
  return MIME_BY_EXT[ext] || 'application/octet-stream'
}

export const useContent = ({ user }) => {

  const { content } = useContext(DataContext)
  const [contentItem, loadingCon, errorCon, refreshCon] = content;

  return [contentItem, loadingCon, errorCon, refreshCon];
};

export const useUpload = ({ user }) => {
  return {
    upload: (content, file, progressListener, index, length) => {
      const filename = content.filename
      const path = content.path || ('content/' + user.clientId + '/' + content.id + '/' + filename)

      const storage = getStorage()
      const fileRef = storageRef(storage, path)

      // Some browsers leave file.type empty for uppercase extensions (e.g. .MP4),
      // which breaks the video transcode trigger. Infer it from the extension.
      const metadata = file.type ? undefined : { contentType: guessContentType(filename) }

      const task = uploadBytesResumable(fileRef, file, metadata)

      return new Promise((resolve, reject) => {
        task.on('state_changed', 
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            progressListener(progress, file.name, index, length)
          }, 
          (error) => {
            reject(error)
          },
          () => {
            getDownloadURL(task.snapshot.ref).then((downloadURL) => {
              resolve({ snapshot: task.snapshot, url: downloadURL })
            })
        })
      })
    }
  }
}
